import Icon from '../components/Icon.vue'

Icon.register({"quote-right":{"width":512,"height":512,"paths":[{"d":"M464 32H336C309.5 32 288 53.5 288 80V208C288 234.5 309.5 256 336 256H416V320C416 355.3 387.3 384 352 384H344C330.7 384 320 394.7 320 408V456C320 469.3 330.7 480 344 480H352C440.4 480 512 408.4 512 320V80C512 53.5 490.5 32 464 32zM176 32H48C21.5 32 0 53.5 0 80V208C0 234.5 21.5 256 48 256H128V320C128 355.3 99.3 384 64 384H56C42.7 384 32 394.7 32 408V456C32 469.3 42.7 480 56 480H64C152.4 480 224 408.4 224 320V80C224 53.5 202.5 32 176 32z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/quote-right.js
// module id = zL1c
// module chunks = 0